<div class="flex flex-col h-[114px] bg-[#D0DEFF] rounded-lg border-[1px] border-[#9DB5E3] p-4 mb-4">
  <p class="text-[#25508E] text-base font-sans font-bold leading-[18px]"><img src="assets/images/form_vault.svg" /> Vault</p>
  <div class="w-full">
    <div class="flex justify-between w-full">
      <button
        [matMenuTriggerFor]="menuItemVault"
        [matTooltip]="selected_vault?.name"
        class="text-[#25508E] bg-[#fff] font-bold text-[13px] text-truncate mr-[6px] w-[180px] h-[42px] flex items-center justify-between rounded-lg border-[1px] border-[#d3dce8b2] cursor-pointer px-4 hover:bg-[#f5f5f5] hover:border-[#b1acb0] hover:text-[#25508E] hover:shadow-md flex-1"
        [ngClass]="
          selected_vault?.name || is_loading
            ? 'border border-[1px] border-solid border-[#d3dce8b2] '
            : 'border border-[1px] border-solid border-[#ff0000]'
        "
      >
        <div class="flex w-full items-center">
          @if(ai_suggested_item && selected_vault && selected_vault?.id === ai_suggested_item?.id){
          <img src="assets/images/ai_suggestion_small.svg" class="w-6 h-6" />
          }
          <span
            style="width: calc(100% - 60px)"
            [ngClass]="selected_vault?.name || is_loading ? 'text-[#25508E]' : 'text-[#ff0000]'"
            class="text-truncate"
          >
            {{ selected_vault?.name ? (selected_vault?.name | truncateStrPipe : 30) : 'Select Vault' }}
          </span>
          @if(selected_vault?.id == -1){
          <span class="bg-[#D1F6E1] leading-6 mx-1 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded"> New </span>
          }
          <img src="assets/images/Chevron_Down.svg" style="height: 30px" class="" />
        </div>
        <!-- @if(selected_vault?.name || is_loading){
        <img src="assets/images/Chevron_Down.svg" style="height: 30px; margin-top: 6px" class="ml-2" />
        }@else{
        <img src="assets/images/red-dropdown.svg" style="height: 30px; margin-top: 6px" class="ml-2" />
        } -->
      </button>
      <mat-menu #menuItemVault="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel remove-paadin-bottom-menu">
        <div class="app__centered-item w-full h-full" style="padding: 12px; border-bottom: 1px solid #b1acb066">
          <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
          <input
            class="h-full w-full ml-2 border-none outline-none text-[13px]"
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="'Search Vault'"
            (click)="$event.stopPropagation()"
            (input)="onInputChange($event.target.value)"
          />
          @if (searchText) {
          <span
            (click)="clearSearchAction(); $event.stopPropagation()"
            class="material-icons relative bg-white text-[#898F9E] text-[22px] leading-7 hover:cursor-pointer"
            >clear</span
          >
          }
        </div>
        <div style="height: 200px; max-height: 200px; overflow-y: auto; width: 280px; padding-top: 12px">
          @if(ai_suggested_item){
          <button
            mat-menu-item
            class="popup-menu-item"
            style="width: 264px; height: 48px !important"
            (click)="selected_vault = ai_suggested_item; updateVaultSelection(ai_suggested_item)"
          >
            <div class="flex">
              <img src="assets/images/ai_suggestion.svg" class="w-8 p-1 h-8 bg-[#EBF0FA] rounded" alt="icon" />
              <div class="ml-1" style="width: 154px; display: flex; flex-direction: column; position: relative; top: 8px; left: 2px">
                <p class="text-[12px] font-semibold text-[#18191c]" style="margin-bottom: 4px">
                  {{ ai_suggested_item.name | truncateStrPipe : 14 }}
                </p>
                <p
                  class="text-[10px] font-medium m-0 text-base font-normal text-[#010B18]"
                  style="
                    background: linear-gradient(180deg, #3e75ff, #8400ff, #e367ff);
                    -webkit-background-clip: text;
                    font-size: 10px !important;
                    -webkit-text-fill-color: transparent;
                  "
                >
                  Kinnect Ai Suggestion
                </p>
              </div>
              @if(ai_suggested_item?.id == -1){
              <span
                class="bg-[#D1F6E1] leading-6 mx-1 w-9 h-6 text-[#1AA140] font-bold text-[10px] rounded"
                style="text-align: center; margin-top: 4px"
              >
                New
              </span>
              }
            </div>
          </button>
          } @for (vault of vault_list| filterList : searchText; track vault) { @if(ai_suggested_item?.id !== vault?.id){
          <button
            mat-menu-item
            class="popup-menu-item mb-2"
            style="width: 264px; height: 48px !important"
            (click)="selected_vault = vault; updateVaultSelection(vault)"
          >
            <div class="flex" style="margin-top: 6px">
              <img [src]="'assets/images/' + vault.type + '-small.svg'" class="w-8 p-2 h-8 bg-[#EBF0FA] rounded" alt="icon" />
              <div class="ml-1" style="display: flex; flex-direction: column; position: relative; top: 9px">
                <p class="text-[12px] font-semibold text-[#18191c]">{{ vault.name | truncateStrPipe : 25 }}</p>
                <p class="capitalize text-[#707070] text-[10px] font-medium">{{ vault.type }}</p>
              </div>
            </div>
          </button>
          } } @if (vault_list?.length >0 && (vault_list | filterList : searchText).length == 0) {
          <div class="text-center text-[#898F9E] text-[14px]">No vaults found</div>
          }
        </div>
        <button
          mat-menu-item
          disableRipple
          class="cy-add-new-vault-btn-menu popup-menu-item p-0 h-[42px] bg-[#EBF0FA]"
          style="justify-content: center"
          (click)="addNewVault()"
        >
          <p class="menuitem-text text-[#25508E] text-[14px] font-bold">
            <mat-icon class="text-[#25508E]">add</mat-icon>
            Create New
          </p>
        </button>
      </mat-menu>
      <button
        mat-icon-button
        aria-label="download icon"
        [ngClass]="selected_vault ? 'bg-[#25508E]' : 'bg-[#c1c2c5]'"
        (click)="selected_vault ? onSaveVault() : null; $event.stopPropagation()"
        class="save-btn w-[76px] cursor-pointer text-[#fff] text-xs font-semibold rounded h-[42px]"
      >
        Save
      </button>
    </div>
  </div>
</div>
